import React from 'react';
import axios from 'axios';
import { render, screen, fireEvent, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import Index from './index';

jest.mock('axios');

describe('CompanyGroup', () => {
  describe('Index', () => {
    test('renders', async() => {

      const m_company_groups = [ {id: 1, group_id: "groupA", name: "group_name_A"} , {id: 2, group_id: "groupB", name: "group_name_B"} ]

      render(<Index m_company_groups={m_company_groups}/>);

      // タイトル
      expect(screen.getByRole("heading", {name: "企業グループ一覧"})).toBeInTheDocument();

      // ボタン類
      expect(screen.getByText('企業グループ作成')).toBeInTheDocument();

      // 表示エリア
      expect(screen.getByRole("row", {name: "グループID グループ名"})).toBeInTheDocument();
      expect(screen.getByRole("row", {name: "groupA group_name_A 編集 削除"})).toBeInTheDocument();
      expect(screen.getByRole("row", {name: "groupB group_name_B 編集 削除"})).toBeInTheDocument();
    });  
  }); 
});